module.exports = {
  path: 'how_it_works',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/HowItWorks'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/more/routes/how_it_works/index.js